import { ServiceProviderType } from "@/types/index";
import { FieldRow } from "../../../components/molecules/FieldsTable";
import { NotAvailable } from "../../Dashboard/RequestDetails/NotAvailable";
import { readableAccountNextSteps } from "@/utils/accounts";

export const SocialMediaOrEmailAccount = ({
  account,
  serviceProviderType,
}: {
  account: any;
  serviceProviderType: ServiceProviderType;
}) => {
  return (
    <>
      <FieldRow label="Email address" value={account.emailAddress || <NotAvailable />} />

      {serviceProviderType === ServiceProviderType.SocialMedia && (
        <>
          <FieldRow label="Phone number" value={account.phoneNumber || <NotAvailable />} />

          <FieldRow label="Email address" value={account.emailAddress || <NotAvailable />} />
        </>
      )}

      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(account.nextStep, serviceProviderType)}
      />
    </>
  );
};
